<div class="generic-banner" *ngIf="generic?.banner">
	<app-image [natural]="false" [url]="generic.banner"></app-image>
</div>
<div class="gutter">
	<div class="generic flx-col" *ngIf="generic">
		<h1 class="gutter-v-half">{{ generic?.name }}</h1>
		{{ generic?.content }}
	
		<div class="gallery flx-row flx-wrap-grid flx-wrap-grid-2-xs flx-wrap-grid-3-sm flx-wrap-grid-3-md">
			<div class="gallery-image" *ngFor="let slide of generic?.photos; let i = index">
				<a [href]="cdn +'/'+ slide.module +'/'+ slide.dir +'/'+ slide.filename">
					<app-image [natural]="false" [url]="cdn +'/'+ slide.module +'/'+ slide.dir + '/medium_'+ slide.filename"></app-image>
				</a>
			</div>
		</div>
	</div>
	
	<div class="generic generic-info flx-row flx-btwn-cntr flx-gap-default" *ngIf="generic">
		<a class="icon-link" [routerLink]="['/'+path_list]">
			<span i18n>wróć do listy</span>
		</a>
	</div>
</div>